import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CROSS_PLATFORM_SIDEBAR_COLLABORATOR_TRANSLATION_KEY } from "../constants";
var pt = /*#__PURE__*/_defineProperty({}, CROSS_PLATFORM_SIDEBAR_COLLABORATOR_TRANSLATION_KEY, {
  MODULE_HOME: 'Início',
  MODULE_RECOGNITION: 'Reconhecimento',
  MODULE_PERFORMANCE: 'Desempenho',
  MODULE_CLIMATE: 'Clima',
  MODULE_LEARNING: 'E-Learning',
  MODULE_COMPANY: 'Companhia',
  MODULE_ANALYTICS: 'Análise',
  MODULE_MY_TEAM: 'Minha Equipe',
  MODULE_MY_RESULTS: 'Meus Resultados',
  TOOLTIP_CLIMATE_DESCRIPTION: 'Mede a cultura e satisfação da sua equipe.',
  TOOLTIP_PERFORMANCE_DESCRIPTION: 'Avalia o desempenho, através de objetivos e competências.',
  TOOLTIP_LEARNING_DESCRIPTION: 'Gerencia estratégias de aprendizado e potencializa as habilidades de suas equipes.',
  TOOLTIP_RECOGNITION_DESCRIPTION: 'Gerencia as medalhas concedidas pelos colaboradores.',
  TOOLTIP_COMPANY_DESCRIPTION: 'Monitora seus processos e gera relatórios.',
  TOOLTIP_ANALYTICS_DESCRIPTION: 'Consulta os resultados dos processos em que você participa.',
  TOOLTIP_MY_RESULTS_TITLE: 'Resultados',
  TOOLTIP_MY_RESULTS_DESCRIPTION: 'Analisa seus resultados e os da equipe que você lidera.',
  SUBMODULE_RESULTS_TITLE: 'Meus resultados',
  SUBMODULE_TOOLTIP_MY_RESULTS_DESCRIPTION: 'Consulta os resultados dos processos em que participa',
  SUBMODULE_LEADER_RESULTS_TITLE: 'Minha equipe',
  SUBMODULE_TOOLTIP_LEADER_RESULTS_DESCRIPTION: 'Monitora os resultados da sua equipe',
  TOOLTIP_TITLE_MY_RESULTS: 'Meus Resultados',
  TOOLTIP_DESCRIPTION_MY_RESULTS: 'Consulte os resultados dos processos em que você participa.',
  TOOLTIP_TITLE_MODULE_MY_TEAM: 'Minha Equipe',
  TOOLTIP_DESCRIPTION_MODULE_MY_TEAM: 'Monitore os processos ativos e resultados da sua equipe.',
  SUBMODULE_ACTIVE_PROCESSES: 'Seguimento',
  SUBMODULE_TOOLTIP_ACTIVE_PROCESSES_DESCRIPTION: 'Gerencie a participação da sua equipe de forma centralizada.',
  SUBMODULE_MY_TEAM_RESULTS: 'Resultados',
  TOOLTIP_DESCRIPTION_SUBMODULE_MY_TEAM_RESULTS: 'Analise os resultados dos processos concluídos.',
  SUBMODULE_DIRECTORY_TITLE: 'Diretório',
  SUBMODULE_TOOLTIP_DIRECTORY_DESCRIPTION: 'Informações dos membros da companhia',
  SUBMODULE_COMPANY_CHART_TITLE: 'Organograma',
  SUBMODULE_COMPANY_CHART_DESCRIPTION: 'Conheça a estrutura da companhia',
  SUBMODULE_RECOGNITION_TITLE: 'Medalhas',
  SUBMODULE_TOOLTIP_RECOGNITION_DESCRIPTION: 'Envie medalhas aos seus colegas e veja as que recebeu',
  SUBMODULE_RECOGNITION_REDEMPTION_TITLE: 'Recompensas',
  SUBMODULE_TOOLTIP_RECOGNITION_REDEMPTION_DESCRIPTION: 'Resgate os pontos que obteve por seus feitos',
  SUBMODULE_OKRS_PERFORMNACE_TITLE: 'OKRs',
  SUBMODULE_TOOLTIP_OKRS_PERFORMANCE_DESCRIPTION: 'Visualize o progresso da estratégia empresarial e reconheça o esforço para cumprir os objetivos',
  SUBMODULE_GOALS_TITLE: 'Metas',
  SUBMODULE_TOOLTIP_GOALS_DESCRIPTION: 'Planeje e estabeleça seus compromissos de trabalho',
  SUBMODULE_COMPETENCES_TITLE: 'Avaliações',
  SUBMODULE_TOOTLTIP_COMPETENCES_DESCRIPTION: 'Acesse os questionários dos processos atribuídos',
  SUBMODULE_FEEDBACK_TITLE: 'Feedback',
  SUBMODULE_TOOLTIP_FEEDBACK_DESCRIPTION: 'Avalie os processos de feedback da sua empresa.',
  SUBMODULE_PID_TITLE: 'Plano Individual de Desenvolvimento',
  SUBMODULE_TOOLTIP_PID_DESCRIPTION: 'Crie processos para fechar lacunas e promover o crescimento.',
  SUBMODULE_SUCESSION_PLAN_TITLE: 'Plano de Sucessão',
  SUBMODULE_TOOLTIP_SUCESSION_PLAN_DESCRIPTION: 'Crie planos de ação para futuras vagas.',
  SUBMODULE_CLIMATE_EVALUATION_TITLE: 'Avaliações de Clima',
  SUBMODULE_TOOLTIP_CLIMATE_EVALUATION_DESCRIPTION: 'Acesse o questionário para mediar o clima organizacional',
  SUBMODULE_SURVEY_TITLE: 'Pesquisas',
  SUBMODULE_TOOLTIP_SURVEY_DESCRIPTION: 'Ajude sua empresa a coletar informações de maneira rápida e fácil',
  // Learning links
  LEARNING_LINK_LEARND_AND_PROGRESS: 'APRENDIZAGEM E PROGRESSO',
  LEARNING_LINK_ENROLLED_COURSES: 'Cursos',
  LEARNING_LINK_TOOLTIP_MORE_FOR_YOU_DESCRIPTION: 'Descubra os novos conteúdos de aprendizado',
  LEARNING_LINK_PATHS: 'Trilhas de aprendizagem',
  LEARNING_LINK_LIVE_SESSIONS: 'Sessões ao vivo',
  LEARNING_LINK_NOTES: 'Anotações',
  LEARNING_LINK_STUDY_PLAN: 'Plano de Estudos',
  LEARNING_LINK_TOOLTIP_STUDY_PLAN: 'Planeje sua meta de aprendizado',
  LEARNING_LINK_MENTORSHIP: 'Mentorias',
  LEARNING_LINK_TOOLTIP_MENTORSHIP: 'Solicite orientação com especialistas',
  LEARNING_LINK_BLOG: 'Blog',
  LEARNING_LINK_LIVES: 'Lives',
  LEARNING_LINK_TOOLS: 'Ferramentas',
  LEARNING_LINK_EVALUATIONS_AND_GOALS: 'AVALIAÇÃO E CONQUISTAS',
  LEARNING_LINK_SKILL_XP: 'Skill XP',
  LEARNING_LINK_PROJECTS: 'Projetos',
  LEARNING_LINK_TOOLTIP_PROJECTS_DESCRIPTION: 'Realize os projetos dos seus cursos',
  LEARNING_LINK_DIPLOMA: 'Diplomas',
  LEARNING_LINK_TOOLTIP_DIPLOMA_DESCRIPTION: 'Consulte os diplomas obtidos pelo cumprimento do seu aprendizado',
  LEARNING_LINK_PENDING_TESTS: 'Testes Pendentes',
  LEARNING_LINK_DONE_TESTS: 'Testes Resolvidos',
  LEARNING_LINK_ACCHIEVEMENTS: 'Conquistas',
  LEARNING_LINK_REWARDS: 'Recompensas',
  LEARNING_LINK_SKILL_XP_EVOLUTION: 'Evolução de Skill XP',
  LEARNING_LINK_TOOLTIP_SKILL_XP_EVOLUTION_DESCRIPTION: 'Faça os testes e identifique o nível das suas habilidades',
  LEARNING_LINK_GAMIFICATION: 'Gamificação',
  LEARNING_LINK_TOOLTIP_GAMIFICATION_DESCRIPTION: 'Ganhe recompensas por suas conquistas de aprendizado',
  LEARNING_LINK_MY_COURSES: 'Meus Cursos',
  LEARNING_LINK_TOOLTIP_MY_COURSES_DESCRIPTION: 'Acesse cursos e caminhos em que está inscrito',
  LEARNING_LINK_RESOURCES: 'Recursos',
  LEARNING_LINK_TOOLTIP_RESOURCES_DESCRIPTION: 'Recursos de aprendizado',
  LEARNING_LINK_COURSES: 'Cursos',
  LEARNING_LINK_DISCOVER: 'Descubra',
  LEARNING_LINK_KNOWLEDGE_HUB: 'Catálogo',
  // Misc
  SIDEBAR_BACK: 'Voltar',
  SIDEBAR_BACK_TO_PRODUCTS: 'Voltar para meus produtos',
  SIDEBAR_EXPAND: 'Expandir menu',
  SIDEBAR_COLLAPSE: 'Recolher menu',
  SIDEBAR_HELP: 'Ajuda',
  SIDEBAR_HELP_DESCRIPTION: 'Acesse recursos e suporte de suporte.',
  MODULE_PRODUCTS_SUBTITLE: 'PRODUTOS'
});
export default pt;